import {css} from 'lit';

// language=CSS
export const audioInputEntry =
    css`
        .container {
            display: grid;
            grid-template-columns: 45px auto 70px;
            grid-column-gap: var(--sp-default-padding);
            grid-auto-flow: column;
            height: 45px;
            width: 100%;
        }
        
        .container.view-mode  {
            grid-template-columns: var(--sp-audio-input-view-mode-button-size, 45px) auto;
            grid-column-gap: calc(var(--sp-default-padding) / 2);
            height: max(var(--sp-audio-input-view-mode-button-size, 45px), var(--sp-audio-input-view-mode-waveform-height, 45px));
        }

        
        .wave {
            width: 100%;
            height: 80%;
            place-self: center;
            box-sizing: border-box;
        }
        
        .wave.view-mode {
            height: var(--sp-audio-input-view-mode-waveform-height, 45px);
        }

        .play {
            width: 100%;
            height: 100%;
            place-self: center;
            border-radius: 0;
        }
        
        .play.view-mode {
            width: var(--sp-audio-input-view-mode-button-size, 45px);
            height: var(--sp-audio-input-view-mode-button-size, 45px);
        }
        
        .container.view-mode .play {
            border-radius: 50%;
        }

        .delete {
            background-color: rgb(var(--sp-greylight));
            border-radius: 30px;
            height: 30px;
            width: 30px;
            place-self: center end;
        }
        
        sp-button.stopped::part(icon)  {
            background-position: 58% center;
        }
    `;
